<template>
  <div>
    <generic-modal
      :height="OrderDetailsModalDim.height"
      :width="OrderDetailsModalDim.width"
      :padding="OrderDetailsModalDim.padding"
      :modalClass="OrderDetailsModalDim.modalClass"
      overflowNotNeeded="true"
      contentScroll="1"
      v-if="isAdvancedOrderDetailPage"
    >
      <template v-slot:header>
        <div class="sticky-top">
          <div
            class="plr16 pt16 pb16 d-flex align-items-center"
            :class="[clientPlatform == 'Web' ? 'dt-mw-670' : 'border-bottom']"
          >
            <i class="hkfi-back fs-14 mr15 hand" @click="handleBackClick"></i>
            <div class="header-order-details">
              <span class="fs-14 bold lh24">Order Details</span>
              <span class="header-help" @click="handleHelpCTA">Help</span>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:body>
        <div
          class="plr16"
          :class="[clientPlatform == 'Web' ? 'dt-mw-670' : '']"
        >
          <advance-order-details-card></advance-order-details-card>
          <order-price-card
            class="pt16"
            :src="'advance-order'"
          ></order-price-card>
        </div>
        <!-- @todo: not implementing in phase 1 -->
        <!-- <download-bill></download-bill> -->
      </template>
      <template v-slot:footer>
        <div class="footer-order-details-cta plrb16 pt3">
          <button class="send-otp-button" @click="reorderCtaHandler">
            {{ ctaText }}
          </button>
        </div>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import GenericModal from "./GenericModal.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { OrderHistoryPages } from "../helpers/orderHistoryConstants";
import Utility from "../helpers/utility";
import { clientPlatform } from "../config/apiEndpoints";

import {
  EVENT_CLICK_REORDER,
  EVENT_CLICK_HELP_TRACK_ORDER,
} from "../helpers/analyticsEvents";

export default {
  name: "AdvanceOrderDetails",
  components: {
    GenericModal,
    AdvanceOrderDetailsCard: defineAsyncComponent(() =>
      import("./AdvanceOrderDetailsCard.vue")
    ),
    OrderPriceCard: defineAsyncComponent(() => import("./OrderPriceCard.vue")),
    DownloadBill: defineAsyncComponent(() => import("./DownloadBill.vue")),
  },
  props: {},
  data() {
    return {
      clientPlatform,
      OrderDetailsModalDim: {
        width: "100vw",
        height: "100vh",
        padding: "0px",
        modalClass: "full-screen-popup advance-order-modal",
      },
    };
  },
  mounted() {
    // if(LocalStorageFunc.getOrderSummary()) {
    //   this.$store.commit(keyMapsMutation.UPDATE_ORDER_SUMMARY, LocalStorageFunc.getOrderSummary());
    //   //console.log('order-summary',this.$store.state.OrderTracking.orderSummary);
    //   //LocalStorageFunc.unsetKey('orderSummary');
    // }
  },
  methods: {
    handleBackClick(e) {
      LocalStorageFunc.setOrderHistoryPage(OrderHistoryPages.MY_ORDERS);
      if (LocalStorageFunc.getPrevUrl().includes("/cart-unified")) {
        Utility.redirectToHomeOrRedirectUrl();
      } else Utility.redirectToOrderHistoryOrRedirectUrl();
    },
    reorderCtaHandler(event) {
      event.cancelBubble = true;
      event.preventDefault();
      EVENT_CLICK_REORDER({
        category: "Re-order Clicked",
      });
      let items = LocalStorageFunc.getOrderSummary()?.items;
      this.addToCartOnReorder(items);
      LocalStorageFunc.setOrderHistoryPage(OrderHistoryPages.MY_ORDERS);
      Utility.sendToCartScreen();
    },
    addToCartOnReorder(items = []) {
      let reorderedItems = LocalStorageFunc.getReorderedItems();
      reorderedItems = [...reorderedItems, ...items];
      LocalStorageFunc.setReorderItemsOrder(reorderedItems);
    },
    handleHelpCTA() {
      Utility.sendToHelpPage();
      EVENT_CLICK_HELP_TRACK_ORDER({});
    },
  },
  computed: {
    ctaText() {
      return "Reorder";
    },
    isAdvancedOrderDetailPage() {
      return (
        LocalStorageFunc.getOrderHistoryPage() ==
        OrderHistoryPages.ADVANCED_ORDER_DETAIL
      );
    },
  },
};
</script>
